<button mat-flat-button>
  {{ label | transloco }}
</button>
